import CollapsibleBand from './collapsible-band';
export * from './collapsible-band';
export default CollapsibleBand;
